import React, { useEffect } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { Link, useParams } from 'react-router-dom';
import { LeadStagesCard } from '../Component/Lead Stages Component/LeadStagesCard';
import GetAppIcon from '@mui/icons-material/GetApp';
import { Get_All_Lead_stages_Data_Action } from '../Redux/Actions/Lead_Stages_Changed_Action';
import { useDispatch, useSelector } from 'react-redux';
import XLSX from '../utils/excelUtils';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';

export const LeadStagespage = () => {
  const dispatch = useDispatch();
  const { id } = useParams();

  //user login
  let userloginrealy = [];
  if (localStorage.getItem('user') !== null) {
    userloginrealy = JSON.parse(localStorage.getItem('user'));
  }
  const Get_Lead_stages_Updated_data = async () => {
    await dispatch(Get_All_Lead_stages_Data_Action(id));
  };

  useEffect(() => {
    Get_Lead_stages_Updated_data();
  }, []);

  const resallLeadstages_Changed = useSelector(
    (state) => state.AllLeads_Stages_Changed.Lead_Stages_changed,
  );

  let resallLeadstages_Changedarray = Array.isArray(resallLeadstages_Changed?.data)
    ? resallLeadstages_Changed.data
    : [];

  const flattenData = (data) => {
    if (!Array.isArray(data)) {
      console.error('Expected an array but received:', data);
      return []; // إذا لم تكن البيانات مصفوفة، أعد مصفوفة فارغة لتجنب أخطاء أخرى
    }
    return data.map((item) => ({
      id: item._id || 'N/A',
      Lead_Name: item.LeadId ? item.LeadId.name : 'N/A',
      sales: item.sales ? item.sales.name : 'N/A',
      date: item.date || 'N/A',
    }));
  };
  // Export Data To Excell
  const exportToExcel = () => {
    const flattenedData = flattenData(resallLeadstages_Changedarray); // تسطيح البيانات
    if (flattenedData.length === 0) {
      console.error('No data to export');
      return;
    }
    const ws = XLSX.utils.json_to_sheet(flattenedData); // تحويل البيانات إلى ورقة Excel
    const wb = XLSX.utils.book_new(); // إنشاء ملف Excel جديد
    XLSX.utils.book_append_sheet(wb, ws, 'Leads Data Stages (Changed)'); // إضافة الورقة إلى الملف
    XLSX.writeFile(wb, 'data.xlsx'); // حفظ المل
  };

  const getLinkByRole = (role) => {
    switch (role) {
      case 'Sales':
        return '/AllLeadsForSales';
      case 'Admin':
        return '/AllLeadsForAdmin';
      case 'Marketer':
        return '/ALLLeadsForMarketer';
      case 'Team Leader':
        return '/AllLeadsForTeamLeader';
      case 'Manager':
        return '/LeadsForManagers';
      default:
        return '/'; // أو أي مسار افتراضي
    }
  };

  const role = userloginrealy?.data?.role;
  const path = getLinkByRole(role);
  return (
    <Container className="startpage fade-in">
      <Row>
        <Col sm={2}></Col>

        <Col sm={10}>
          <div
            className="d-flex flex-wrap align-items-center mb-3"
            style={{ gap: '0.5rem', fontSize: '1.1rem' }}
          >
            <Link
              to={path}
              style={{ textDecoration: 'none', color: '#0F7687', fontWeight: 'bold' }}
            >
              Home
            </Link>
            <KeyboardDoubleArrowRightIcon style={{ color: '#0F7687' }} />
            <span style={{ color: '#333' }}>Lead Stages Stage</span>
          </div>

          <div
            onClick={exportToExcel}
            className="mx- my-3"
            style={{
              background: '#0F7687',
              color: 'white',
              width: '210px',
              textAlign: 'center',
              padding: '10px',
              cursor: 'pointer',
              borderRadius: '5px',
            }}
          >
            Export Data To Excell
            <GetAppIcon />{' '}
          </div>
          <div>Count Of Stages For This Lead {`(${resallLeadstages_Changedarray.length})`}</div>
          <div className="d-flex flex-wrap">
            {resallLeadstages_Changedarray
              ? resallLeadstages_Changedarray
                ? resallLeadstages_Changedarray.map((items, index) => {
                    return <LeadStagesCard key={index} item={items} />;
                  })
                : null
              : null}
          </div>
        </Col>
      </Row>
    </Container>
  );
};
